<script setup>
import {ref, reactive, onMounted, inject, onBeforeUnmount, watch, nextTick, useTemplateRef, computed} from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import { useStore } from 'vuex';

const notify = inject('notify');

const isActive = ref(false)

const props = defineProps({
    isLoading: {
        type: Boolean,
        required: true,
    },
});

</script>

<template>
    <div class="preloader" v-if="isLoading">
        <div class="loading-icn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3C16.97 3 21 7.03 21 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </div>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;
    .preloader {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(10px);
        z-index: 30;
    }

    .loading-icn {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 1;

        animation-name: loading-icn;
        animation-duration: 300ms;
        animation-iteration-count: infinite;
        animation-direction: normal;
    }

    .loading-icn path {
        stroke: rgba($purple, 0.8)
    }

    .loading-icn svg {
        width: 7%;
        height: 7%;
    }

    @media screen and (max-width: 750px) {
        .loading-icn svg {
            width: 12%;
            height: 12%;
        }
    }
</style>